import React from 'react';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import ArrowIcon from 'assets/svg/right.svg';
import { Text } from 'ds/components/typography';
import BackLink from 'components/navigation/BackLink';

const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

const Root = styled.div<{ noMarginBottom: boolean }>(({ theme, noMarginBottom }) => ({
  'a': {
    display: 'inline-block',
    color: theme.colors.neutrals.grey1,
    textDecoration: 'none',
  },
  marginBottom: noMarginBottom ? 0 : theme.spacing(2),
}));

export const BackButton: React.FC<{ noMarginBottom?: boolean }> = React.memo(({ noMarginBottom = false }) => {
  const { t } = useLocale();

  return (
    <Root noMarginBottom={noMarginBottom}>
      <BackLink>
        <Wrapper>
          <ArrowIcon width={24} height={24}/>
          <Text weight="medium" data-auto="back-button-text">
            {t('developersSearchCityPage.back')}
          </Text>
        </Wrapper>
      </BackLink>
    </Root>
  );
});
